<template>
  <div>
    <header v-if="isIframe">
      <information-navigation />
      <pages-navigation />
    </header>
    <main>
      <b-container fluid class="pt-0 pb-5 p-0" id="content">
        <b-container>
          <b-row>
            <b-col cols="12" :xl="isIframe ? 10 : 12">
              <router-view />
            </b-col>
            <b-col cols="12" xl="2" class="py-2"  v-if="isIframe">
              <right-sidebar />
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </main>
    <footer class="footer"  v-if="isIframe">
      <footer-component />
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import InformationNavigation from '@/components/Header/InformationNavigation.vue';
import PagesNavigation from '@/components/Header/PagesNavigation.vue';
import RightSidebar from '@/components/RightSidebar.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { AppModule } from '@/store/modules/app';
import { ColorModule } from '@/store/modules/color';
import cssVars from 'css-vars-ponyfill';

@Component({
  components: {
    InformationNavigation,
    PagesNavigation,
    RightSidebar,
    FooterComponent,
  },
})
export default class DefaultTemplate extends Vue {
  get isIframe() {
    return !AppModule.isIframe;
  }

  get color() {
    return {
      '--aba-primary': ColorModule.basicColor.color_1,
      '--aba-primary-filter': ColorModule.basicColor.color_1_filter,
      '--aba-primary-rgba': ColorModule.basicColor.color_1_rgba,
      '--aba-secondary': ColorModule.basicColor.color_2,
      '--aba-secondary-filter': ColorModule.basicColor.color_2_filter,
      '--aba-secondary-rgba': ColorModule.basicColor.color_2_rgba,
    };
  }

  created() {
    cssVars({
      variables: this.color,
    });
  }
}
</script>
